<template>
    <div class="transfer-terms">
        <div v-for="(message, index) in messages" :key="index" class="transfer-terms-message">
            <strong>{{ message.title }}</strong>
            <p>{{ message.description }}</p>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, computed, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { TransferProduct } from '@/api/Cart/cart.interfaces';
    import { getStaticTransferTerms } from '@/helpers/transfer/transfer';
    import { TransferImportantMessage } from '@/helpers/transfer/transfer.interfaces';
    import { isNotNil } from '@shared/utils/value';

    export default defineComponent({
        name: 'Terms',
        props: {
            product: {
                type: Object as PropType<TransferProduct>,
                required: true,
            },
        },
        setup(props) {
            const messages = computed<TransferImportantMessage[]>(() => {
                return [
                    props.product.DisclaimerDescription && {
                        title: props.product.DisclaimerTitle ?? '',
                        description: props.product.DisclaimerDescription,
                    },
                    ...getStaticTransferTerms(),
                    props.product.CancellationPolicyText && {
                        title: t({ key: 'cancellation.cancellation_policy' }),
                        description: props.product.CancellationPolicyText,
                    },
                ].filter(isNotNil) as TransferImportantMessage[];
            });

            return { messages };
        },
    });
</script>

<style scoped lang="scss">
    @forward 'Terms';
</style>
